export default "__VITE_ASSET__B9wZi5sV__"